import { render } from "./NcrmMailjetContactsTab.vue?vue&type=template&id=277a6a10&scoped=true"
import script from "./NcrmMailjetContactsTab.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetContactsTab.vue?vue&type=script&lang=js"

import "./NcrmMailjetContactsTab.vue?vue&type=style&index=0&id=277a6a10&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277a6a10"]])

export default __exports__